import React from "react";
import { TbUserDollar } from "react-icons/tb";

const RiAuctionLineIcon = () => {
    return <TbUserDollar style={{ width: "30px", height: "50px" }} />;
};

export default RiAuctionLineIcon;
